module.exports = __webpack_public_path__ + "0c1dac95a757d243724692894c3f0b91.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gewonnen_level_2_opgewekt.mp3
// module id = 66
// module chunks = 0